import { msalInstance } from '../utils/msalInstance';
import { AuthenticationResult, InteractionRequiredAuthError } from '@azure/msal-browser';
import { loginRequest } from '../../authConfig';

let msalReadyPromise: Promise<void> | null = null;

export function setMsalReadyPromise(promise: Promise<void>) {
  msalReadyPromise = promise;
}

export async function getMsalReadyPromise(): Promise<void> {
  if (msalReadyPromise) {
    await msalReadyPromise;
  }
}

export async function getAccessToken(): Promise<string> {
  if (msalReadyPromise) await msalReadyPromise;
  const account = msalInstance.getActiveAccount();
  if (!account) throw new Error('No active account');
  try {
    const response: AuthenticationResult = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account,
    });
    return response.accessToken;
  } catch (error: any) {
    if (error instanceof InteractionRequiredAuthError) {
      // Save the current url for redirect after login
      sessionStorage.setItem('postLoginRedirect', window.location.pathname + window.location.search);

      // Fallback to interactive login
      await msalInstance.acquireTokenRedirect({
        ...loginRequest,
        account,
      });
      // The redirect will leave this function, so no return needed
      return ""; // This line is never reached, but satisfies TypeScript
    }
    throw error;
  }
}